import { render, staticRenderFns } from "./ExceptionClaimV2.vue?vue&type=template&id=3eb400c6&"
import script from "./ExceptionClaimV2.vue?vue&type=script&lang=js&"
export * from "./ExceptionClaimV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports